<template>
  <div class="wrapper">
    <div class="questionWrapper col-md-6 col-sm-12 m-auto" v-for="(obj, index) in questions" :key="index">
      <p class="question pt-4 pb-4" v-html="obj.question"></p>
      <div class="radioWraper" :style="`-webkit-column-count: ${obj.divide ? obj.divide : 1};-moz-column-count: ${obj.divide ? obj.divide : 1};column-count: ${obj.divide ? obj.divide : 1}`">
        <div
          class="radioClass pb-4"
          v-for="(option, jIndex) in obj.options" :key="jIndex"
        >
          <div v-if="!obj.checkbox">
            <input
              v-model="localSelected[index]"
              type="radio"
              :name="index"
              :id="`${index}_${jIndex}`"
              :value="option.text"
              :disabled="false"
              @click.passive="optionSelected(index , jIndex)"
              class="cursorPointer"
            />
            <label :for="`${index}_${jIndex}`" class="answerLabel">{{
              option.text
            }}</label>
          </div>
          <div v-else>
            <input
              v-model="localCheckBoxSelected"
              type="checkbox"
              :name="index"
              :id="`${index}_${jIndex}`"
              :value="option.text"
              :disabled="false"
              @click.passive="optionSelected(index , jIndex)"
              class="cursorPointer"
            />
            <label :for="`${index}_${jIndex}`" class="answerLabel">{{
              option.text
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: "survey",
  props: {
    questions: {
      type: Array,
      default: () => []
    }
  },
  watch : {
    localCheckBoxSelected (newv) {
      console.log(newv)
    }
  },
  mounted () {
    let temp = []
    for (let i in this.questions) {
      temp.push("")
    }
    this.setSurveyResult(temp)
    this.$eventHub.$on("sendSurvey", this.send)
  },
  beforeDestroy () {
    this.$eventHub.$off("sendSurvey", this.send)
  },
  computed: {
    ...mapGetters(['surveyResult',"customerToken", "campaignId", "receiptToken"])
  },
  methods: {
    ...mapActions(['setSurveyResult', 'sendFormData']),
    optionSelected (i , j) {
      setTimeout( () => {
        this.setSurveyResult(this.localSelected)
      }, 0)
    },
    async send (skipSurvey) {
      const formData = {}
      formData.customerToken = this.customerToken;
      formData.campaignId = this.campaignId;
      formData.receiptToken = this.receiptToken
      if (!skipSurvey) {
        let resultOfQuestion1 = ""
        this.localCheckBoxSelected.forEach(obj => resultOfQuestion1 += obj + ' ; ')
        if (this.surveyResult === []) this.surveyResult.push(resultOfQuestion1)
        else this.surveyResult[0] = resultOfQuestion1
        this.surveyResult.forEach((item , index) => {
          formData[`question${index+1}`] = item
        })
      }
      const presistentFormFields = {};
      if (this.keepInState) {
        this.keepInState.forEach(field => {
          presistentFormFields[field] = this.$store.state.formData[field];
        });
      }
      this.$store.commit("setField", {
        field: "formData",
        value: { ...presistentFormFields, ...formData }
      });
      this.sendFormData({ formData: formData , apiUrl: "https://js-backend.justsnap.eu/api/submitSurvey" }).then(res => {
        this.$store.commit("setField", {
          field: "formData",
          value: {
            ...presistentFormFields,
            ...formData,
            ...res
          }
        });
        if(res.referenceNumber !== undefined) {
          this.$store.commit("setReferenceNumber", res.referenceNumber)
        }
        console.log(this.$store.state.formData['referenceNumber'])
        this.goToPage('thankYou' , this)
      })
    }
  },
  data () {
    return {
      localSelected: [],
      localCheckBoxSelected: [],
      keepInState: ["referenceNumber"]
    }
  }
}
</script>

<style scoped lang="scss">
.radioWraper {
  @media (max-width: 768px) {
    column-count: 1 !important;
    .radioClass {
      padding: 5px !important;
    }
  }
}
.question {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 19px;
    padding-bottom: 5px !important;
  }
}

.answerLabel {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 19px;
  }
}

input {
  display: none;

  &:checked {
    + label:before {
      display: none;
    }

    + label:after {
      width: 20px;
      left: 0;
      top: 0;
      height: 20px;
      content: "";
      background-image: url("../../assets/icons/checked.svg") !important;
      background-repeat: no-repeat;
      background-size: 20px;
      position: absolute;
    }
  }
}

label {
  padding-left: 40px;
  padding-right: 30px;
  position: relative;

  margin: 0px;

  letter-spacing: 0px;
  color: #000000;
  opacity: 1;

  &:before {
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    content: "";
    background-image: url("../../assets/icons/unchecked.svg") !important;
    background-repeat: no-repeat;
    background-size: 20px;
    position: absolute;
  }
}
</style>